import { useLocation } from 'react-router-dom';
export function usePathPrefix() {
    const { pathname } = useLocation();
    const prefix = pathname.split('/')[1];
    return prefix;
}
